import type { InterventionNature } from '../../../lib/api/v2/planning'
import { cn } from '../../../lib/utils'

/** Pill classes per nature — LINE_STATUS_CLASS idiom (supplier-orders-helpers.ts). */
const NATURE_META: Record<Exclude<InterventionNature, 'Initial'>, { label: string; className: string; ariaLabel: string }> = {
  Finition: {
    label: 'Finition',
    className: 'border border-amber-400 bg-amber-50 text-amber-700',
    ariaLabel: 'Finition — retour sur le chantier après la pose initiale',
  },
}

/**
 * Nature badge for a second intervention (SOLY-FINITION-001). A LABEL only — the text is always
 * present so colour is never the only signal. Renders nothing for the Initial (Phase-1) pose:
 * the normal case stays visually calm.
 */
export function InterventionNatureBadge({ nature }: { nature: InterventionNature }) {
  if (nature === 'Initial') return null
  const meta = NATURE_META[nature]
  // Rollout tolerance: a missing/unknown nature degrades to no badge — it must never take the
  // whole planning surface down. Unreachable per the type, load-bearing at runtime: during the
  // SOLY-PLAN-003 deployment window a cached payload can still carry the removed 'Sav'.
  if (!meta) return null
  return (
    <span
      data-testid="intervention-nature-badge"
      data-nature={nature}
      aria-label={meta.ariaLabel}
      className={cn('rounded px-1.5 py-0.5 text-[10px] font-medium', meta.className)}
    >
      {meta.label}
    </span>
  )
}
